import { data } from '../../svg/Flow/data';
import { makeIcon } from '../makeIcon';

export const Flow = makeIcon(data, 'flow', 'Flow');

export default Flow;
